export default __webpack_public_path__ + "static/media/interested-icon-on.0a5fc8bc.svg";